import { render, staticRenderFns } from "./shop-detail-info.vue?vue&type=template&id=0e5f0140&scoped=true&"
import script from "./shop-detail-info.vue?vue&type=script&lang=js&"
export * from "./shop-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./shop-detail-info.vue?vue&type=style&index=0&id=0e5f0140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5f0140",
  null
  
)

export default component.exports